import { makeStyles } from '@mui/styles';
import background_solutions from 'src/assets/background_solutions.png';
import background_solutions_2 from 'src/assets/background_solutions_2.png';

const useStyles = makeStyles({
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(100%)', // Empieza desde la derecha
    },
    '100%': {
      transform: 'translateX(0)', // Termina en su posición original
    },
  },
  solutionsContainer: {
    width: '60%', // Limita el ancho al 60%
    margin: '0 auto', // Centra horizontalmente
    animation: '$slideIn 1s ease-out',
    textAlign: 'center',
    padding: '1rem',
    color: '#fff',
    '@media (max-width: 1200px)': {
      width: '80%', // Aumenta el ancho en tablets
      padding: '0.5rem',
    },
    '@media (max-width: 768px)': {
      width: '95%', // Ocupa casi todo el ancho en dispositivos móviles
      padding: '0.25rem',
    },
  },
  mainSolutions: {
    backgroundImage: `url(${background_solutions})`,
    backgroundSize: '80%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '@media (max-width: 1200px)': {
      backgroundSize: '90%', // Ajusta el tamaño del fondo en tablets
    },
    '@media (max-width: 768px)': {
      backgroundSize: '100%', // Ajusta el tamaño del fondo en móviles
    },
  },
  secondSolutions: {
    backgroundImage: `url(${background_solutions_2})`,
    backgroundSize: '70%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '@media (max-width: 1200px)': {
      backgroundSize: '90%', // Ajusta el tamaño del fondo en tablets
    },
    '@media (max-width: 768px)': {
      backgroundSize: '100%', // Ajusta el tamaño del fondo en móviles
    },
  },
  solutionsTitle: {
    margin: '0.5rem 0',
    background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (max-width: 1200px)': {
      marginTop: '3rem',
    },
    '@media (max-width: 768px)': {
      fontSize: '2.5rem', // Reduce el tamaño del título en móviles
    },
  },
  solutionsDescription: {
    marginBottom: '1.5rem',
    '@media (max-width: 768px)': {
      fontSize: '1.9rem', // Reduce el tamaño de la descripción en móviles
    },
  },
  newSection: {
    display: 'flex',
    flexDirection: 'row', // Este estilo asegura que los elementos se muestren en una fila
    marginTop: '2rem',
    alignItems: 'center', // Esto asegura que la imagen y el texto estén alineados verticalmente
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Cambia a columna en dispositivos móviles
      alignItems: 'center', // Centra los elementos en móviles
      textAlign: 'center', // Centra el texto en móviles
    },
  }, 
  imageContainer: {
    flex: '0 0 auto', // Evita que la imagen crezca o se encoja
    textAlign: 'left',
    marginRight: '1rem', // Ajusta este margen para separar la imagen un poco del texto
    '@media (max-width: 768px)': {
      marginRight: '0', // Elimina el margen derecho en móviles
      marginBottom: '1rem', // Añade margen inferior en móviles
      textAlign: 'center', // Centra las imágenes en móviles
    },
  },
  contentContainer: {
    flex: '1',
    padding: '0.5rem',
    textAlign: 'left',
    '@media (max-width: 768px)': {
      textAlign: 'center', // Centra el texto en móviles
      padding: '0.25rem', // Reduce el padding en móviles
    },
  },
  largeImage: {
    width: '350px', // Ajusta el ancho de la imagen para hacerla más grande
    height: 'auto',
    margin: '0 auto', // Centra la imagen
    marginBottom: '0.5rem', // Reduce el espacio debajo
    '@media (max-width: 768px)': {
      width: '80%', // Reduce el tamaño de la imagen en móviles
    },
  },
  titleImage: {
    maxWidth: '35%',
    height: 'auto',
    marginBottom: '0.5rem',
    '@media (max-width: 768px)': {
      maxWidth: '50%', // Aumenta el tamaño del logo en móviles
    },
  },
  titleImageOrkestaMedia: {
    width: '350px',
    height: 'auto',
    marginBottom: '0.5rem',
    '@media (max-width: 768px)': {
      width: '80%', // Reduce el tamaño del logo en móviles
    },
  },
  description: {
    margin: '0.5rem 0',
    '@media (max-width: 768px)': {
      fontSize: '1.9rem', // Reduce el tamaño del texto en móviles
    },
  },
  buttonContainer: {
    marginTop: '1rem',
    display: 'flex',
    gap: '1rem',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Apila los botones en móviles
      alignItems: 'center', // Centra los botones en móviles
    },
  },
  buttonSecondary: {
    padding: '1rem',
    color: '#fff',
    backgroundColor: '#00A8E8',
    border: '2px solid #00A8E8',
    borderRadius: '100px',
    cursor: 'pointer',
    marginBottom: '2rem',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#fff',
    },
    '@media (max-width: 768px)': {
      padding: '0.75rem', // Aumenta el padding en móviles para facilitar el clic
      width: '100%', // Ocupa todo el ancho disponible
    },
  },
  bulletPointsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    margin: '1rem 0',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Apila los bullet points en móviles
      alignItems: 'center', // Centra los bullet points en móviles
    },
  },
  bulletPointGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    '@media (max-width: 768px)': {
      alignItems: 'center', // Centra los bullet points en móviles
    },
  },
  bulletPoint: {
    margin: '0.5rem 0',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 768px)': {
      fontSize: '1.4rem', // Reduce el tamaño del texto en móviles
    },
  },
  bullet: {
    marginRight: '0.5rem', // Separar el bullet del texto
  },
});

export default useStyles;

